import { api } from './client'

// MOCK-ONLY API — advisor consumer referrals. This is a UI/UX design
// surface: the real feature (share links that actually mint, stage
// transitions driven by intake/booking/RO events, the pay policy) is a
// later build. Real BE: ❌ no counterpart yet.

export type ReferralStage =
  | 'invited'
  | 'showed_up'
  | 'estimate'
  | 'booked'
  | 'completed'

export interface Referral {
  id: number
  advisorUserId: number
  teamId: number
  name: string
  phone: string | null
  vehicleLabel: string | null
  stage: ReferralStage
  stageAt: string
  createdAt: string
  /** Demo reward figure — the real pay policy is a later product decision. */
  rewardAmount: number | null
  estimateId: number | null
}

export const referralsApi = {
  byAdvisor: (userId: number | string) =>
    api.get<Referral[]>(`/referrals/advisor/${userId}`),
}
